import { useEffect } from 'react';
import { openModal } from '@kcd/app-interface/dist/web2app';
import { trackEvent } from '@kcd/event-tracker';

import { useMembershipStatus } from '../../hooks/useMembershipStatus';

import {
  BonuspackCloverFill18x18Icon,
  CheveronRightIcon24x24,
  MembershipStandard28x14Icon,
} from '~/assets/icons';
import {
  BonuspackCouponNudgeImg,
  MembershipCouponNudgeImg,
} from '~/assets/img/cashnote-membership/nudge';

export function CommonProductCrossSellBottomSheetNudge() {
  const {
    isMembershipSubscribeServiceAvailable,
    isTrialAvailable,
    isAvailableToSubscribe,
    isAvailableToSubscribeBonusPack,
    getRegisterMembershipUrl,
  } = useMembershipStatus();

  const nudgeType = (() => {
    if (isTrialAvailable) {
      return 'plus_membership_free';
    }

    if (isAvailableToSubscribe) {
      return 'plus_membership';
    }

    if (isAvailableToSubscribeBonusPack) {
      return 'lucky_bonus_pack';
    }

    return '';
  })();

  useEffect(() => {
    if (nudgeType) {
      trackEvent('viewed banner in 마켓/상품상세/멤버십넛지', {
        clicked_area: 'product_recommend_bottom_sheet',
        membership_nudge_type: nudgeType,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickRegisterMembership = () => {
    const registerUrl = getRegisterMembershipUrl();

    trackEvent('clicked button in 마켓/상품상세/멤버십넛지', {
      clicked_area: 'product_recommend_bottom_sheet',
      membership_nudge_type: nudgeType,
    });

    if (registerUrl) {
      openModal({
        url: registerUrl,
      });
    }
  };

  const nudgeContent = (() => {
    if (isTrialAvailable) {
      return (
        <>
          <div className="flex-1">
            <div className="flex gap-8">
              <div className="flex size-[90px] items-center justify-center rounded-12 border border-02">
                <img src={MembershipCouponNudgeImg.src} alt="" />
              </div>
              <div className="flex flex-1 flex-col justify-center gap-2">
                <p className="flex items-center gap-4 typo-paragraph100-regular">
                  <MembershipStandard28x14Icon />총 6만원 쿠폰팩
                </p>
                <strong className="flex text-membershipBlue-text typo-title100-semibold">
                  첫 4주 무료체험
                </strong>
                <p className="flex text-description typo-footnote300-semibold">
                  매월 33,000원
                </p>
              </div>
            </div>
          </div>
          <div className="flex basis-32 items-center">
            <div className="flex size-32 items-center justify-center rounded-full border border-solid border-primary-regular">
              <CheveronRightIcon24x24 className="[&_path]:fill-blue-600" />
            </div>
          </div>
        </>
      );
    }

    if (isAvailableToSubscribe) {
      return (
        <>
          <div className="flex-1">
            <div className="flex gap-8">
              <div className="flex size-[90px] items-center justify-center rounded-12 border border-02">
                <img src={MembershipCouponNudgeImg.src} alt="" />
              </div>
              <div className="flex flex-1 flex-col justify-center gap-2">
                <p className="flex items-center gap-4 typo-paragraph100-regular">
                  <MembershipStandard28x14Icon />총 6만원 쿠폰팩
                </p>
                <p className="flex text-membershipBlue-text typo-title100-semibold">
                  매월 33,000원
                </p>
                <strong className="flex text-description typo-footnote300-semibold">
                  가입 즉시 쏟아지는 혜택!
                </strong>
              </div>
            </div>
          </div>
          <div className="flex basis-32 items-center">
            <div className="flex size-32 items-center justify-center rounded-full border border-solid border-primary-regular">
              <CheveronRightIcon24x24 className="[&_path]:fill-blue-600" />
            </div>
          </div>
        </>
      );
    }

    if (isAvailableToSubscribeBonusPack) {
      return (
        <>
          <div className="flex-1">
            <div className="flex gap-8">
              <div className="flex size-[90px] items-center justify-center rounded-12 border border-02">
                <img src={BonuspackCouponNudgeImg.src} alt="" />
              </div>
              <div className="flex flex-1 flex-col justify-center gap-2">
                <p className="flex items-center gap-4 typo-paragraph100-regular">
                  <BonuspackCloverFill18x18Icon />
                  구독료보다 더 돌려드려요
                </p>
                <p className="flex text-membershipBlue-text typo-title100-semibold">
                  매월 19,800원
                </p>
                <strong className="flex text-description typo-footnote300-semibold">
                  총 2만원 쿠폰팩에 보너스할인까지!
                </strong>
              </div>
            </div>
          </div>
          <div className="flex basis-32 items-center">
            <div className="flex size-32 items-center justify-center rounded-full border border-solid border-primary-regular">
              <CheveronRightIcon24x24 className="[&_path]:fill-blue-600" />
            </div>
          </div>
        </>
      );
    }

    return null;
  })();

  if (!isMembershipSubscribeServiceAvailable) return null;

  return (
    <button
      type="button"
      className="flex w-full gap-16"
      onClick={onClickRegisterMembership}
    >
      {nudgeContent}
    </button>
  );
}
